'use strict';
ui.loadTemplateFile('serverselect.html');

class ServerSelectDialog extends Dialog {
  _element: any;
  _titleBar: any;
  _serverList: any;
  _servers: any;

  constructor(servers: any) {
    super('serverselect.html');

    this._serverList = ui.list(this, '.list.servers');
    this._serverList.on('itemdoubleclicked', this._selectServer.bind(this));

    this._servers = servers;
    this._update();
    this.center();
  }

  _update() {
    this._serverList.clear();

    for (let i = 0; i < this._servers.length; ++i) {
      const item = ui.listitem();
      item.html(this._servers[i].name);
      this._serverList.append(item);
    }

    this._serverList.index(0);
  }

  _selectServer(index: any) {
    index = index || this._serverList.index();
    this.emit('done', this._servers[index].id);
    this.close();
  }
}

ui.ServerSelectDialog = ServerSelectDialog;
ui.serverSelectDialog = (servers: any) => {
  return new ui.ServerSelectDialog(servers);
};
